import type { Instance } from "@/api/client";
import { reviewState } from "@/flow/decisions";
import type { BBoxNorm } from "@/viewer/bbox";
import { unitOf } from "@/viewer/PanelOverlay";

/** The box two corners span, whichever way the pointer was dragged. */
export function spanned(a: { x: number; y: number }, b: { x: number; y: number }): BBoxNorm {
  return {
    x0: Math.min(a.x, b.x),
    y0: Math.min(a.y, b.y),
    x1: Math.max(a.x, b.x),
    y1: Math.max(a.y, b.y),
  };
}

/**
 * The panels of one configuration whose centre lies in a box: a block an estimator drags
 * over to relabel together (Phase 7 K4). On The Ellis a code's last number holds across
 * rectangles of floors and bays, so one box per block is the fewest corrections. Other
 * configurations inside the box, and rejected panels, are left out.
 */
export function panelsInBox(
  instances: readonly Instance[],
  box: BBoxNorm,
  unitId: string,
): Instance[] {
  return instances.filter((instance) => {
    if (unitOf(instance) !== unitId || reviewState(instance) === "rejected") {
      return false;
    }
    const b = instance.bbox_norm;
    const cx = (b.x0 + b.x1) / 2;
    const cy = (b.y0 + b.y1) / 2;
    return cx >= box.x0 && cx <= box.x1 && cy >= box.y0 && cy <= box.y1;
  });
}
